<template>
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">{{gallery.name[$i18n.locale]}}</p>
            <div class="modal-card-icon">
                <b-button @click="$parent.close()">
                    <b-icon icon="close"></b-icon>
                </b-button>
            </div>
        </header>
        <div class="modal-card-body">
            <gallery :images="gallery.elements" :index="index" @close="index = null"></gallery>
            <div
                class="image"
                v-for="(image, imageIndex) in gallery.elements"
                :key="imageIndex"
                @click="index = imageIndex"
                :style="{backgroundImage: `url('${image}')`, backgroundSize: 'cover', backgroundPosition: 'center', width: '100px', height: '100px' }"
            >
            </div>
        </div>
    </div>
</template>
<script>
    import VueGallery from "vue-gallery";

    export default {
        props: ["gallery"],
        data(){
            return{
                index: null
            }
        },
        components: {
            "gallery": VueGallery
        },
    }
</script>
<style scoped>
    .image {
        width: 25%;
        float: left;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        border: 1px solid #ebebeb;
        margin: 5px;
    }
</style> 